export default {
	getData: function (state) {
		return state.data;
	}
}
